$(document).ready(function () {
    let main = $("main"),
        body = $("body"),
        windowWidth = $(window).width();
    var onSlickReady = window.mobidevOnSlickReady || function (cb) {
        if ($.fn && $.fn.slick) {
            cb();
        }
    };

    if (main.is('.page-services-5') || main.is('.page-services-6') || main.is('.page-services-7') || main.is('.page-services-8')) {
        $(window).on('stopResize orientationchange', function (event) {
            videosInit();
            clientsInit();
            if ($(window).width() < 1921 && windowWidth > 1920) {
                window.location.reload();
            }
            if ($(window).width() > 1920 && windowWidth < 1921) {
                window.location.reload();
            }
            if ($(window).width() < 992 && windowWidth > 991) {
                window.location.reload();
            }
            if ($(window).width() > 991 && windowWidth < 992) {
                window.location.reload();
            }
            if ($(window).width() < 641 && windowWidth > 640) {
                window.location.reload();
            }
            if ($(window).width() > 640 && windowWidth < 641) {
                window.location.reload();
            }
        });
        $(window).on('orientationchange', function (event) {
            body.addClass('orientation-changed');
            window.location.reload();
        });
    }

    onSlickReady(videosInit);
    onSlickReady(clientsInit);
    initTabs();
    initDescriptionTabs();
    arrowBfTabs();
    arrowBfHeight();
    addClassWrapperTechFocus();
    changeHeightCards();
    changeMarginStepper();
    if (!$('#main').hasClass('page-services-9')) {
        onSlickReady(clientsInitFeedback);
    }
    if ($('#wrapper').hasClass('tech-focus')) {
        first();
        scrollResizeDesktop();
        checkScrollButton();
    }

    $(window).resize(function () {
        arrowBfHeight();
        centerLine();
        changeHeightCards();
        changeMarginStepper();

    });

    $('.tech-focus-posts__title a, .tech-focus-item__title a, .tech-focus-posts__more').on('click mousedown touchstart', function (e) {
        let attr = $(this).attr('data-slider-index');

        if (typeof attr !== 'undefined' && attr !== false) {
            localStorage.setItem('slide_index', attr);
        }
    });

    function videosInit() {
        let sliderVideos = $('.js-redesign__slider-videos');
        if (!($.fn && $.fn.slick)) {
            return;
        }

        if (window.innerWidth < 992) {
            sliderVideos.not('.slick-initialized').slick({
                infinite: false,
                speed: 300,
                slidesToShow: 1.3,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1.1
                    }
                }]
            });
        } else {
            if (sliderVideos.length) {
                if (sliderVideos.hasClass('slick-initialized')) {
                    sliderVideos.slick('unslick');
                }
            }
        }
    }

    function clientsInitFeedback() {
        let sliderClients = $('.js-redesign__slider-clients');
        if (!($.fn && $.fn.slick)) {
            return;
        }

        if (window.innerWidth < 992 && $('.js-redesign__slider-clients > *').length > 1) {
            sliderClients.not('.slick-initialized').slick({
                infinite: false,
                speed: 300,
                slidesToShow: 1.3,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1.06
                    }
                }]
            });
        } else {
            if (sliderClients.length) {
                if (sliderClients.hasClass('slick-initialized')) {
                    sliderClients.slick('unslick');
                }
            }
        }
    }

    function initDescriptionTabs() {
        if (window.innerWidth < 992) {
            $('.animation .js-description__item, .js-cards__block').on('click', function (e) {
                // Проверяем, является ли кликнутый элемент ссылкой или находится внутри ссылки
                if ($(e.target).closest('h4 a').length) {
                    return; // Если это ссылка, выходим из функции
                }

                // Остальная логика открытия/закрытия карточки
                if ($(this).hasClass('show')) {
                    $(this).removeClass('show');
                } else {
                    $('.animation .js-description__item, .js-cards__block').removeClass('show');
                    $(this).addClass('show');
                }
            });
        }
    }

    function arrowBfTabs() {
        if (window.innerWidth < 640) {
            $('.js-arrow-bf__item').on('click', function (e) {
                if ($(this).hasClass('show')) {
                    $(this).removeClass('show')
                } else {
                    $('.js-arrow-bf__item').removeClass('show')
                    $(this).addClass('show')
                }
            });
        }
    }

    function arrowBfHeight() {
        if (window.innerWidth > 640) {
            var $height = 2615;
            if (window.innerWidth < 1950) {
                $height = 2600 - (1950 * 1.02 - window.innerWidth);
            }
            if (window.innerWidth < 1800) {
                $height = 2600 - (1950 * 1.05 - window.innerWidth);
            }
            if (window.innerWidth < 1335) {
                $height = 2600 - (1950 * 1.1 - window.innerWidth);
            }
            if (window.innerWidth < 992) {
                $height = 2600 - (992 * 1.05 - window.innerWidth);
            }
            $('.arrow-bf-image').css({
                height: $height
            })
        }
    }

    var scrollLink = $('.js-tech-focus-filters__button');
    scrollLink.on('click', function () {
        var $el = $(this),
            id = $el.attr('href');
        var heightPopup = 0;

        if ($('.js-mobi-popup').length && $('.js-mobi-popup').css('display') != 'none') {
            heightPopup = $('.js-mobi-popup').outerHeight();
        }

        var down = 200 + heightPopup;

        if ($(window).width() <= 992) {
            $(this).siblings().removeClass('active-tech-focus');
            $(this).addClass('active-tech-focus');
            $(id).siblings().removeClass('active-tech-focus');
            $(id).addClass('active-tech-focus');
            down = 159 + heightPopup;
        }
        if (window.innerWidth <= 767) {
            down = 142 + heightPopup;
        }
        if (window.innerWidth <= 640) {
            down = 200 + heightPopup;
        }
        $('html, body').animate({
            scrollTop: $(id).offset().top - down
        }, 500);
        centerLine();

        return false;
    });

    $(window).scroll(function () {
        if (window.innerWidth > 992) {
            var scrollDistance = $(window).scrollTop() + 300;
            var techFocusItems = $('.js-tech-focus-posts').get();
            if (techFocusItems.length > 0) {
                var techFocusLastItemPosition = techFocusItems[techFocusItems.length - 1].getBoundingClientRect().top;
            }

            $('.js-tech-focus-posts').each(function () {
                if ($(this).position().top < scrollDistance) {
                    var $selector = $('a[href="#' + $(this).attr('id') + '"]');
                    $($selector).siblings().removeClass('active-tech-focus');
                    $($selector).addClass('active-tech-focus');
                    $('.tech-focus-filters__grid .active-tech-focus .tech-focus-filters-arrow').css({
                        left: Math.round($('.tech-focus-filters__grid a.active-tech-focus').outerWidth() / 2 - 15)
                    });
                    if (techFocusLastItemPosition > 200) {
                        centerLine();
                    }
                }
            })
        }
    })

    function first() {
        var techFocusPosts = $('.js-tech-focus-posts');

        if (techFocusPosts.hasClass('active-tech-focus') || findVisibleElement(techFocusPosts)) {
            var elements = $('.js-tech-focus-posts');
            var visibleElement = findVisibleElement(elements);
            var $selector = $('a[href="#' + visibleElement.id + '"]');
            $($selector).addClass('active-tech-focus');
            centerLine();
        } else {
            techFocusPosts.first().addClass('active-tech-focus');
            var $id = techFocusPosts.first().attr('id');
            var $selector = $('a[href="#' + $id + '"]');
            $($selector).addClass('active-tech-focus');
            centerLine();
        }
        $('.tech-focus-filters hr ').css({
            display: 'block'
        })
    }

    $('.js-mobi-popup__close').on('click', function () {
        $('.tech-focus-scroll-box').css('top', $('.header').outerHeight());
    });

    function checkScrollButton() {
        const scrollContainer = document.querySelector(".tech-focus-filters");
        if (scrollContainer.scrollLeft + scrollContainer.clientWidth >= scrollContainer.scrollWidth) {
            $('.right-button-tech-focus').addClass('tech-focus-scroll-max');
        } else {
            $('.right-button-tech-focus').removeClass('tech-focus-scroll-max');
        }
        if (scrollContainer.scrollLeft <= 0) {
            $('.left-button-tech-focus').addClass('tech-focus-scroll-max');
        } else {
            $('.left-button-tech-focus').removeClass('tech-focus-scroll-max');
        }
    }


    if (window.innerWidth < 640 && $('#wrapper').hasClass('tech-focus')) {
        document.querySelector('.left-button-tech-focus').addEventListener('click', function () {
            const scrollContainer = document.querySelector('.tech-focus-filters');
            const scrollAmount = 100;
            const scrollDuration = 500;

            const startScrollLeft = scrollContainer.scrollLeft;
            const targetScrollLeft = startScrollLeft - scrollAmount;
            let startTime;

            function scroll(timestamp) {
                if (!startTime) {
                    startTime = timestamp;
                }

                const elapsed = timestamp - startTime;

                if (elapsed < scrollDuration) {
                    const progress = elapsed / scrollDuration;
                    scrollContainer.scrollLeft = startScrollLeft + progress * (targetScrollLeft - startScrollLeft);
                    requestAnimationFrame(scroll);
                } else {
                    scrollContainer.scrollLeft = targetScrollLeft;
                }
            }
            requestAnimationFrame(scroll);
            setTimeout(() => {
                checkScrollButton();
            }, scrollDuration);


        });

        document.querySelector('.right-button-tech-focus').addEventListener('click', function () {
            const scrollContainer = document.querySelector('.tech-focus-filters');
            const scrollAmount = 100;
            const scrollDuration = 500;

            const startScrollLeft = scrollContainer.scrollLeft;
            const targetScrollLeft = startScrollLeft + scrollAmount;
            let startTime;

            function scroll(timestamp) {
                if (!startTime) {
                    startTime = timestamp;
                }

                const elapsed = timestamp - startTime;

                if (elapsed < scrollDuration) {
                    const progress = elapsed / scrollDuration;
                    scrollContainer.scrollLeft = startScrollLeft + progress * scrollAmount;
                    requestAnimationFrame(scroll);
                } else {
                    scrollContainer.scrollLeft = targetScrollLeft;
                }
            }
            requestAnimationFrame(scroll);
            setTimeout(() => {
                checkScrollButton();
            }, scrollDuration);
        });
    }
    var scrollableElements = document.getElementsByClassName("tech-focus-filters");

    for (var i = 0; i < scrollableElements.length; i++) {
        scrollableElements[i].addEventListener("scroll", function (event) {
            checkScrollButton();
        });
    }

    function centerLine() {
        if ($('#wrapper').hasClass('tech-focus')) {
            const $scrollDemo = document.querySelector(".tech-focus-filters");
            var $position = ($('.tech-focus-filters hr').outerWidth() - $('.tech-focus-filters__grid a.active-tech-focus').outerWidth()) / 2;
            $('.tech-focus-filters hr').css({
                left: $('.tech-focus-filters__grid a.active-tech-focus').position().left - $position + $scrollDemo.scrollLeft
            });
        }
    }

    function addClassWrapperTechFocus() {
        var elements = document.getElementsByClassName('tech-focus-filters');
        for (var i = 0; i < elements.length; i++) {
            $('#wrapper').addClass('tech-focus');
        }
    }

    function isElementInViewport(el) {
        var rect = el.getBoundingClientRect();

        return (
            rect.bottom > 200 &&
            rect.top < window.innerHeight
        );
    }

    function findVisibleElement(elements) {
        for (var i = 0; i < elements.length; i++) {
            if (isElementInViewport(elements[i])) {
                return elements[i];
            }
        }
        return null;
    }

    function scrollResizeDesktop() {

        var scrollableContent = $('.tech-focus-filters');
        var isDragging = false;
        var startPosition = 0;
        var scrollPosition = 0;

        scrollableContent.on('mousedown', function (event) {
            if (event.button === 0) {
                isDragging = true;
                startPosition = event.clientX;
                scrollPosition = scrollableContent.scrollLeft();
                event.preventDefault();
            }
        });

        $(document).on('mouseup', function (event) {
            if (event.button === 0) {
                isDragging = false;
                event.preventDefault();
            }
        });

        $(document).on('mousemove', function (event) {
            if (isDragging) {
                var distance = event.clientX - startPosition;
                scrollableContent.scrollLeft(scrollPosition - distance);
                event.preventDefault();
            }
        });
    }

    function initTabs() {
        if (window.innerWidth > 992) {
            $('.js-mobi-tabs__link').on('mouseenter', function () {
                setTimeout(() => {
                    $('.js-mobi-tabs__link').removeClass('active');
                    $(this).addClass('active');
                    $('.js-mobi-tabs__tab').removeClass('show active');
                    $($(this).attr('href')).addClass('show active');
                }, 150);
            });
        } else {
            $('.js-mobi-tabs__link').on('click', function (e) {
                e.preventDefault();
                if ($(this).hasClass('collapsed')) {
                    $(this).parentsUntil('.js-mobi-tabs').find('.js-mobi-tabs__nav > a').addClass('collapsed');
                    $(this).parentsUntil('.js-mobi-tabs').find('.js-mobi-tabs__tab').removeClass('show');
                    $($(this).attr('href')).addClass('show');
                    $(this).removeClass('collapsed');
                } else {
                    $(this).parentsUntil('.js-mobi-tabs').find('.js-mobi-tabs__nav > a').addClass('collapsed');
                    $(this).parentsUntil('.js-mobi-tabs').find('.js-mobi-tabs__tab').removeClass('show');
                }
            });
        }
    }

    getAccordion();

    function getAccordion() {
        var $ourSection = $('.js-mobi-tabs');
        if (window.innerWidth < 992) {
            if (!$ourSection.hasClass('js-accordion-init')) {
                $ourSection.find('.js-mobi-tabs__nav > a').removeAttr('data-toggle').addClass('collapsed');
                $ourSection.find('.js-mobi-tabs__tab').each(function (index) {
                    var $number = $(this).attr('data-tab');
                    $(this).removeClass('tab-pane fade show').addClass('collapse')
                    if ($number) {
                        $(this).insertAfter($(this).parentsUntil('.js-mobi-tabs').find('.js-mobi-tabs__nav a[href="#js-mobi-tabs__tab-' + $number + '"]'));
                    }
                });
                $ourSection.addClass('js-accordion-init');
            }
        } else {
            if ($ourSection.hasClass('js-accordion-init')) {
                $ourSection.find('.js-mobi-tabs__tab').appendTo($ourSection.find('.js-mobi-tabs__content'));
                $ourSection.find('.js-mobi-tabs__tab').removeClass('collapse').addClass('tab-pane fade');
                $ourSection.find('.js-mobi-tabs__tab:first-of-type').addClass('show');
                $ourSection.find('.js-mobi-tabs__nav > a').attr('data-toggle', 'tab');
                $ourSection.removeClass('js-accordion-init');
            }
        }
    }

    function clientsInit() {
        let mobiClients = $('.js-mobi-clients__grid');

        if (mobiClients.length) {
            if (window.innerWidth < 641) {
                mobiClients.not('.slick-initialized').slick({
                    infinite: true,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '5%',
                    initialSlide: 1,
                    autoplay: false,
                    arrows: true,
                    mobileFirst: true,
                    responsive: [{
                        breakpoint: 462,
                        settings: {
                            centerPadding: '15%',
                        }
                    }]
                });
            } else {
                if (mobiClients.hasClass('slick-initialized')) {
                    mobiClients.slick('unslick');
                }
            }
        }
    }

    let dwidth = $(window).width();
    $(window).on('resize', function (event) {
        let wwidth = $(window).width();

        if (dwidth !== wwidth) {
            let mobiClients = $('.js-mobi-clients__grid');

            if (window.innerWidth < 641) {
                if (mobiClients.length) {
                    if (mobiClients.hasClass('slick-initialized')) {
                        if (mobiClients[0].slick !== undefined) {
                            mobiClients.slick('refresh');
                        }
                    }
                }
            }
        }
    });


    firstTab();

    function firstTab() {
        if ($('.js-mobi-tabs__link').hasClass('active')) {} else {
            $('.js-mobi-tabs__nav').addClass('active');
            $('.js-mobi-tabs__link').first().addClass('active');
            $('.js-mobi-tabs__link').first().removeClass('collapsed');
            $('.js-mobi-tabs__tab').first().addClass('show active');

        }
    }

    function changeHeightCards() {
        if (window.innerWidth > 992) {
            var maxHeight = 0;
            $(".js-cards__block > div").height('auto')
            $(".js-cards__block > div").each(function () {
                var height = $(this).height();
                if (height > maxHeight) {
                    maxHeight = height;
                }
            });

            $(".js-cards__block > div").height(maxHeight - 30);
            $('.js-cards__block div.blocks-description__item-line').height('25%');
        }
    }

    function changeMarginStepper() {
        if (window.innerWidth > 991 && $(".stepper-item-container__list")) {
            var maxHeight = 0;
            $(".stepper-item-container__list").each(function () {
                var height = $(this).height();
                if (height > maxHeight) {
                    maxHeight = height;
                }
            });
            var marginButton = $('.stepper-item__connector').height() + maxHeight;
            $(".stepper-container").css("margin-bottom", marginButton);
        }
    }

    onSlickReady(sliderVideoFeedback);

    function sliderVideoFeedback() {
        if (!($.fn && $.fn.slick)) {
            return;
        }
        $('.feedback-black-js').slick({
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true
        })
    }
    if (!$('#main').is('.page-services-5') && document.querySelector('.feedbacks-block__feedback-content')) {
        feedbackHover()
    }

    function feedbackHover() {

        let feedbackContent = document.querySelector('.feedbacks-block__feedback-content');
        let grandParentNextElement = feedbackContent.parentElement.parentElement.nextElementSibling;

        if (window.innerWidth > 992) {
            $('.feedbacks-block__feedback-content').hover(
                function () {
                    var $height = this.offsetHeight;
                    $('.feedbacks-block__feedback-content').css({
                        maxHeight: $height,
                        height: $height
                    })
                    $(this).css({
                        height: 'auto',
                        maxHeight: 'none'
                    });
                    $(this).find('.feedbacks-block__feedback-text-hover').css({
                        display: 'contents',
                        opacity: 1
                    });
                    var $heightNew = this.offsetHeight;
                    var $marginTop = 100 - ($heightNew - $height);
                    $('h3.feedbacks-block__link').css('margin-top', $marginTop);

                    $(grandParentNextElement).css('z-index', -1)

                },
                function () {
                    $('.feedbacks-block__feedback-text-hover').css({
                        display: 'none',
                        opacity: 0
                    });
                    $('h3.feedbacks-block__link').css('margin-top', 100);
                    $('.feedbacks-block__feedback-content').css({
                        maxHeight: 'auto',
                        height: 'auto'
                    })
                    $(grandParentNextElement).css('z-index', 1)
                }
            );
        }
    }
    onSlickReady(sliderAwards)

    function sliderAwards() {
        if (!($.fn && $.fn.slick)) {
            return;
        }
        var $slider = $('.awards-block__js');

        $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            pauseOnHover: false,
            pauseOnFocus: false,
            pauseOnDotsHover: false,
            dots: true
        });

        var isScrolling = false;

        $slider.on('touchstart', function () {
            isScrolling = true;
        });

        $slider.on('touchend', function () {
            isScrolling = false;
            $slider.slick('slickPlay');
        });

        $(window).on('scroll', function () {
            if (isScrolling) {
                $slider.slick('slickPause');
            }
        });
    }

    const listItems = document.querySelectorAll('.python-page-list__list-item-expandable');

    listItems.forEach(item => {
        if (window.innerWidth > 992) {
            item.addEventListener('mouseenter', () => {
                listItems.forEach(otherItem => {
                    otherItem.classList.remove('expanded');
                });
                item.classList.add('expanded');
            });
        } else {
            item.addEventListener('click', (event) => {

                var clickedElement = event.target;
                if (item.classList.contains('expanded')) {
                    if (!clickedElement.matches('a.python-page-list__title')) {
                        item.classList.remove('expanded');
                    }
                } else {
                    listItems.forEach(otherItem => {
                        otherItem.classList.remove('expanded');
                    });
                    item.classList.add('expanded');
                }

            })
        }
    });

    onSlickReady(function () {
        $('.slider-block').slick({
            arrows: true,
            // adaptiveheight: true,
            slidesToShow: 4,
            appendArrows: $('.slider-arrows-container'),
            responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    variableWidth: true,
                }
            }],
        });
        const slider = $(".technology-we-use").find(".slider-block")[0];
        if (slider) {
            const listItems = $(".technology-we-use").find(".slider-item");
            if (listItems.length > 4) {
                $(".slider-block").css("width", "auto");
            }
        }
    });

    const myList = $(".team-of-developers").find(".slick-track");
    const elementToHide = $(".team-of-developers").find(".dots-container");
    const listItemsTeam = $(".team-of-developers").find(".carousel-item-wrapper");

    if (listItemsTeam.length > 3) {
        if (myList && elementToHide) {

            if (listItemsTeam.length <= 3) {
                $(".dots-container").css("display", "none");
            }
        }

        onSlickReady(function () {
            if (window.innerWidth > 640) {
                $('.js-slider-team-block').slick({
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    dots: true,
                    appendArrows: $('.arrows-container'),
                    appendDots: $('.dots-container'),
                })
            } else {
                $('.js-slider-team-block').slick({
                    rows: 3,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    appendArrows: $('.arrows-container'),
                    appendDots: $('.dots-container'),
                })
            }
        });
    }

});
